// components/Loader.tsx

const Loader: React.FC = () => {
  return (
    <div className="geo-loader-screen" role="status" aria-live="polite">
      <div className="geo-loader">
        <div className="geo-radar" aria-hidden="true">
          <span className="geo-radar-ring ring-1" />
          <span className="geo-radar-ring ring-2" />
          <span className="geo-radar-ring ring-3" />
          <span className="geo-radar-sweep" />
          <span className="geo-radar-dot" />
        </div>
        <div className="geo-loader-text">
          <div className="geo-loader-title">GeoVerse</div>
          <div className="geo-loader-subtitle">
            Scanning terrain intelligence
          </div>
        </div>
        <div className="geo-loader-bar" aria-hidden="true">
          <span />
        </div>
      </div>
    </div>
  );
};

export default Loader;
